import api from '../api';

/**
 * Servicio del módulo DT (Dirección del Trabajo)
 * Descarga el CSV del Libro de Remuneraciones Electrónico (LRE) para cargar en Mi DT
 */

/**
 * Descarga el CSV del LRE del período. El nombre del archivo lo fija el backend.
 * Si el backend responde con error, lanza un Error con su mensaje.
 */
export const descargarLre = async (idCompany, mes, anio) => {
  let response;
  try {
    response = await api.get('/api/rrhh/dt/descargar-lre', {
      params: { id_company: idCompany, mes, anio },
      responseType: 'blob'
    });
  } catch (err) {
    // Con responseType blob, el JSON de error del backend también llega como Blob
    let message = 'Error al generar el Libro de Remuneraciones';
    if (err.response?.data instanceof Blob) {
      try {
        message = JSON.parse(await err.response.data.text()).message || message;
      } catch {
        // La respuesta no era JSON: queda el mensaje genérico
      }
    }
    throw new Error(message);
  }

  const contentDisposition = response.headers['content-disposition'];
  const match = contentDisposition && contentDisposition.match(/filename="(.+)"/);
  const nombreArchivo = match ? match[1] : `lre_${anio}${String(mes).padStart(2, '0')}.csv`;

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = nombreArchivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
